import React from "react"
import PropTypes from "prop-types"
import { PricePropTypes } from "@src/graphql-fragments/prices"
import FormBooking from "./forms/form-booking/form-booking"
import FormContext from "./forms/form-context"

const TourBookingRequestFormWrapper = ({
  product,
  bookingTerms,
  availability,
}) => {
  return (
    <FormContext>
      <FormBooking
        bookingTerms={bookingTerms}
        product={product}
        availability={availability}
      />
    </FormContext>
  )
}
TourBookingRequestFormWrapper.propTypes = {
  product: PropTypes.shape({
    id: PropTypes.string,
    price: PropTypes.shape({
      amount: PricePropTypes.amount,
      currency: PricePropTypes.currency,
    }),
    title: PropTypes.string,
    itinerary: PropTypes.shape({
      locationStart: PropTypes.string,
      locationEnd: PropTypes.string,
    }),
    durationNights: PropTypes.number,
    operator: PropTypes.string,
  }),
  bookingTerms: PropTypes.shape({
    title: PropTypes.string,
    content: PropTypes.string,
  }),
  availability: PropTypes.shape({
    daysOfWeek: PropTypes.arrayOf(PropTypes.number),
    fixedDates: PropTypes.arrayOf(
      PropTypes.shape({
        start: PropTypes.string,
        finish: PropTypes.string,
      }),
    ),
    months: PropTypes.arrayOf(PropTypes.number),
  }),
}
export default TourBookingRequestFormWrapper
